"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var defaultOptions = {
  reconnectTimings: [1000, 5000, 10000, 60000, 120000]
};

var _default =
/*#__PURE__*/
function () {
  function _default(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck2["default"])(this, _default);
    this.stream = null;
    this.url = url;
    this.options = _objectSpread({}, defaultOptions, {}, options);

    this._connect();

    return this;
  }

  (0, _createClass2["default"])(_default, [{
    key: "close",
    value: function close() {
      this._streamConnectionClosedCorrectly = true;

      if (this.isOpen()) {
        this.stream.close();
      }

      return this;
    }
  }, {
    key: "onmessage",
    value: function onmessage(callback) {
      this._onMessage = callback;
    }
  }, {
    key: "onopen",
    value: function onopen(callback) {
      this._onOpen = callback;
    }
  }, {
    key: "onclose",
    value: function onclose(callback) {
      this._onClose = callback;
    }
  }, {
    key: "onerror",
    value: function onerror(callback) {
      this._onError = callback;
    }
  }, {
    key: "send",
    value: function send(data) {
      try {
        data = JSON.stringify(data || {});
      } catch (e) {
        data = '{}';
      }

      if (this.isOpen()) {
        this.stream.send(data);
      }

      return this;
    }
  }, {
    key: "_connect",
    value: function _connect() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      if (this.isAvailable()) {
        this.stream = new WebSocket(url);
        this.stream.onmessage = this._handleMessage.bind(this);
        this.stream.onopen = this._handleOpen.bind(this);
        this.stream.onclose = this._handleClose.bind(this);
        this.stream.onerror = this._handleError.bind(this);
      } else {
        if (process && process.env.NODE_ENV !== 'production') {
          console.log('WebSocket: is not defined');
        }
      }

      return this;
    }
  }, {
    key: "_reconnect",
    value: function _reconnect() {
      if (!this._reconnectTimings) {
        this._reconnectTimings = [].concat(this.options.reconnectTimings);

        this._reconnect();
      } else {
        setTimeout(this._connect.bind(this), this._reconnectTimings.unshift());
      }

      return this;
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      return this.stream && this.stream.readyState === 1;
    }
  }, {
    key: "isClosed",
    value: function isClosed() {
      return this.stream && this.stream.readyState === 3;
    }
  }, {
    key: "isClosing",
    value: function isClosing() {
      return this.stream && this.stream.readyState === 2;
    }
  }, {
    key: "isConnecting",
    value: function isConnecting() {
      return this.stream && this.stream.readyState === 0;
    }
  }, {
    key: "isAborted",
    value: function isAborted() {
      return this._streamConnectionClosedCorrectly !== true;
    }
  }, {
    key: "isAvailable",
    value: function isAvailable() {
      return typeof window['WebSocket'] !== 'undefined';
    }
  }, {
    key: "_handleClose",
    value: function _handleClose(event) {
      if (this.isAborted()) {
        this._reconnect();
      } else {
        if (typeof this._onClose === 'function') {
          this._onClose(event);
        }
      }
    }
  }, {
    key: "_handleMessage",
    value: function _handleMessage(event) {
      if (typeof this._onMessage === 'function') {
        this._onMessage(event);
      }
    }
  }, {
    key: "_handleOpen",
    value: function _handleOpen(event) {
      if (typeof this._onOpen === 'function') {
        this._onOpen(event);
      }
    }
  }, {
    key: "_handleError",
    value: function _handleError(event) {
      if (typeof this._onError === 'function') {
        this._onError(event);
      }
    }
  }]);
  return _default;
}();

exports["default"] = _default;